import React, { useState, useEffect, useContext } from 'react';
import Swal from 'sweetalert2';
import { getGetRequestOptions } from "./GetToken";
import { AppContext } from '../context/AppContext';
import { Button, Modal } from "react-bootstrap";
import LogBookFuelEdit from './LogBookFuelEdit';

function EquipmentFuelLogs({ equipment, logDate, onChange }) {
    const { jwt } = useContext(AppContext);
    const [fuelLogsLoading, setFuelLogsLoading] = useState(false);
    const [equipmentFuelLogs, setEquipmentFuelLogs] = useState([]);
    const [fuelLogEditModalShow, setFuelLogEditModalShow] = useState(false);
    const [fuelLogId, setFuelLogId] = useState(null);


    const fetchEquipmentFuelLogs = React.useCallback((equipmentId, logDate) => {
        setFuelLogsLoading(true);
        setEquipmentFuelLogs([]);

        fetch(`${process.env.REACT_APP_API_URL}log_book/equipment_fuel_logs/${equipmentId}/${logDate}`, {
            ...getGetRequestOptions(),
            headers: {
                ...getGetRequestOptions().headers,
                'Authorization': 'Bearer ' + jwt.token
            }
        })
            .then((resp) => {
                if (!resp.ok) {
                    throw new Error(`HTTP error! status: ${resp.status}`);
                }
                return resp.json();
            })
            .then((resp) => {
                setFuelLogsLoading(false);
                if (resp.success) {
                    setEquipmentFuelLogs(resp.data || []);
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: resp.errorMessage || 'Failed to fetch equipment logs'
                    });
                    setEquipmentFuelLogs([]);
                }
            })
            .catch((error) => {
                setFuelLogsLoading(false);
                console.error('Error fetching equipment logs:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to fetch equipment logs. Please try again.'
                });
                setEquipmentFuelLogs([]);
            });
    }, [jwt]);

    useEffect(() => {
        if (equipment && logDate) {
            fetchEquipmentFuelLogs(equipment.equipmentId, logDate);
        }
    }, [equipment, logDate, fetchEquipmentFuelLogs]);

    const deleteFuelLog = (fuelLogId) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#F64E60',
            cancelButtonColor: '#C1C1C1',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.value) {
                const requestOptions = {
                    method: 'DELETE',
                    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwt.token },
                };
                fetch(process.env.REACT_APP_API_URL + "log_book/fuel_delete/" + fuelLogId, requestOptions)
                    .then((resp) => {
                        return resp.json()
                    })
                    .then((resp) => {

                        if (resp.success === true) {

                            Swal.fire({
                                icon: 'success',
                                title: 'Success',
                                text: resp.successMessage,
                            })
                            // Refresh the logs after deletion
                            fetchEquipmentFuelLogs(equipment.equipmentId, logDate);
                            onChange();
                        }
                        else {
                            var errorsMessage = [];

                            if (resp.errorMessage !== undefined && typeof resp.errorMessage === 'object') {
                                var errorsObj = resp.errorMessage;
                                Object.keys(errorsObj).forEach(function (value) {
                                    errorsObj[value].forEach(function (v) {
                                        errorsMessage.push(v)
                                    });

                                });

                            } else if (resp.errorMessage !== undefined && (typeof resp.errorMessage === 'string' || resp.errorMessage instanceof String)) {
                                errorsMessage.push(resp.errorMessage);
                            } else {
                                errorsMessage.push("Something went wrong");
                            }
                            Swal.fire({
                                icon: 'error',
                                title: resp.heading,
                                text: errorsMessage,
                            })
                        }

                    })
                    .catch((error) => {
                        console.log(error, "catch the hoop")
                    });
            }
        })

    }

    const editFuelLog = (fuelLogId) => {
        setFuelLogId(fuelLogId);
        setFuelLogEditModalShow(true);
    }

    const handleUpdateFuelLog = () => {

        setFuelLogEditModalShow(false);
        fetchEquipmentFuelLogs(equipment.equipmentId, logDate);
        onChange();
    }

    const approveIndividualLog = (idFuelLog) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You want to approve this log entry!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, approve it!',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.value) {
                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + jwt.token
                    },
                    body: JSON.stringify({
                        idFuelLog: idFuelLog
                    })
                };

                fetch(process.env.REACT_APP_API_URL + "log_book/approve_individual_fuel_log", requestOptions)
                    .then((resp) => resp.json())
                    .then((resp) => {
                        if (resp.success) {
                            Swal.fire({
                                icon: 'success',
                                title: 'Success',
                                text: resp.successMessage || 'Fuel Log approved successfully!'
                            });
                            // Refresh the logs after approval
                            fetchEquipmentFuelLogs(equipment.equipmentId, logDate);

                        } else {
                            const errorsMessage = Array.isArray(resp.errorMessage)
                                ? resp.errorMessage.join(', ')
                                : (resp.errorMessage || "Failed to approve fuel log");

                            Swal.fire({
                                icon: 'error',
                                title: resp.heading || 'Error',
                                text: errorsMessage
                            });
                        }
                    })
                    .catch((error) => {
                        console.error('Error approving log:', error);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Failed to approve fuel log. Please try again.'
                        });
                    });
            }
        });
    };

    return (
        <>
            {fuelLogsLoading ? (
                <div className="text-center">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                    <p className="mt-2">Loading equipment fuel logs...</p>
                </div>
            ) : (
                <>
                    {equipmentFuelLogs.length === 0 ? (
                        <div className="text-center">
                            <p>No fuel logs found for this equipment on the selected date.</p>
                        </div>
                    ) : (
                        <>
                            <div className="table-responsive">
                                <table className="table table-bordered table-striped">
                                    <thead className="thead-light">
                                        <tr>
                                            <th>SL</th>
                                            <th>Project</th>
                                            <th>Fuel Type</th>
                                            <th>Refueling Date</th>
                                            <th>Tank Capacity</th>
                                            <th>Fuel Qty</th>
                                            <th>Hrs Meter</th>
                                            <th>Entered By</th>
                                            <th>Status</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {equipmentFuelLogs.map((log, index) => (
                                            <tr key={log.idFuelLog || index}>
                                                <td>{index + 1}</td>
                                                <td>
                                                    {log.projectName || '-'}
                                                </td>
                                                <td>{log.fuelType || '-'}</td>
                                                <td>{log.logDate || '-'}</td>
                                                <td className='text-danger'>{log.tankCapacity || '-'}</td>
                                                <td className='text-primary'>{log.fuelQty || '-'}</td>
                                                <td className='text-info'>{log.hrsMeter || '-'}</td>
                                                <td>{log.enteredBy || '-'}</td>
                                                <td>
                                                    {log.status === 'created' && <span className="badge badge-warning">Created</span>}
                                                    {log.status === 'checked' && <span className="badge badge-success">Approved</span>}
                                                </td>
                                                <td>
                                                    {log.status === 'created' &&

                                                        <div className="btn-group" role="group">
                                                            <Button
                                                                variant="primary"
                                                                size="sm"
                                                                onClick={() => editFuelLog(log.idFuelLog)}
                                                                title="Edit"
                                                                disabled={log.status !== 'created'}
                                                                className="mr-1"
                                                            >
                                                                <i className="fa fa-edit"></i>
                                                            </Button>
                                                            <Button
                                                                variant="danger"
                                                                size="sm"
                                                                onClick={() => deleteFuelLog(log.idFuelLog)}
                                                                title="Delete"
                                                                className="mr-1"
                                                                disabled={log.status !== 'created'}
                                                            >
                                                                <i className="fa fa-trash"></i>
                                                            </Button>
                                                            {log.hasApprovePermission === 1 &&
                                                                <Button
                                                                    variant="success"
                                                                    size="sm"
                                                                    onClick={() => approveIndividualLog(log.idFuelLog)}
                                                                    title="Approve"
                                                                    className="ml-1"
                                                                    disabled={log.status !== 'created'}
                                                                >
                                                                    <i className="fa fa-check"></i>
                                                                </Button>
                                                            }
                                                        </div>
                                                    }


                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <Modal
                                show={fuelLogEditModalShow}
                                onHide={() => setFuelLogEditModalShow(false)}
                                size="lg"
                                backdrop="static"
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title>
                                        Edit Fuel Log for {equipment?.equipmentName || 'Equipment'}<br />
                                        <small className="text-muted">Refueling Date: {logDate}</small>
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <LogBookFuelEdit fuelLogId={fuelLogId} onHide={() => setFuelLogEditModalShow(false)} onUpdateFuelLog={handleUpdateFuelLog} />
                                </Modal.Body>
                            </Modal>
                        </>
                    )}
                </>
            )}
        </>
    );
}

export default EquipmentFuelLogs;